import { Provider } from '@angular/core';

/**
 * services
 */
import { UnitTypeApiService } from './api';
import { UnitTypeService } from './unit-type.service';

/**
 * Route-scoped provider bundle for the Unit Types sub-module: the HTTP
 * layer and the facade that maps its DTOs to models.
 *
 * Declared on the list route, so the page and the form component it hosts
 * share one instance, and the chain lives and dies with the route.
 *
 * The form service is not here — it holds per-modal form state and is
 * declared by the form component itself.
 *
 * @returns The providers to add.
 *
 * @example
 * ```typescript
 * providers: [
 * ...provideUnitTypes(),
 * ],
 * ```
 */
export const provideUnitTypes = (): Provider[] => {

    return [
        UnitTypeApiService,
        UnitTypeService,
    ];
};
